import * as React from "react";
const SvgFiRrDroneAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M23 4h-2a1 1 0 0 0-2 0h-2a1 1 0 0 0 0 2h2v4.248a12.022 12.022 0 0 0-14 .001V6h2a1 1 0 0 0 0-2H5a1 1 0 0 0-2 0H1a1 1 0 0 0 0 2h2v6.039c0 1.298.624 2.513 1.669 3.25.262.185.552.375.854.565C4.767 16.952 4 18.447 4 19.999v1a1 1 0 0 0 2 0v-1c0-.898.468-2.018 1.296-3.173 1.405.665 3.019 1.173 4.704 1.173s3.299-.508 4.704-1.173C17.532 17.981 18 19.101 18 19.999v1a1 1 0 0 0 2 0v-1c0-1.552-.766-3.047-1.522-4.145.302-.19.591-.38.854-.565A3.97 3.97 0 0 0 21 12.039V6h2a1 1 0 0 0 0-2m-7.534 6.62L14.086 12H9.914l-1.379-1.379A10.1 10.1 0 0 1 12 10c1.198 0 2.367.218 3.466.62m2.713 3.035c-1.24.875-3.692 2.344-6.178 2.344s-4.938-1.469-6.178-2.344a1.93 1.93 0 0 1-.695-.949c.48-.447.998-.841 1.545-1.183.039.062.068.129.121.183l2 2a1 1 0 0 0 .707.293h5c.265 0 .52-.105.707-.293l2-2c.054-.054.082-.121.122-.183.547.341 1.065.736 1.544 1.183a1.93 1.93 0 0 1-.695.949"
    />
  </svg>
);
export default SvgFiRrDroneAlt;
